import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'

import { AccountsContextProvider } from '@modules-deprecated/app/accounts'
import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { IsTrustedPartnerContextProvider } from '@modules-deprecated/app/umbrellas'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import {
  EmberActivateIntegration,
  EmberDeactivateIntegration,
  EmberIntegrationContextProvider,
  EmberReloadPaymentMethods,
  Integrations,
} from '@views/integrations'

import { queryClient } from '../../config/queryClient'
import { EmberNavigate, EmberRouterContextProvider } from '../../contexts/emberRouterContext'
import { ThemeProvider } from '../../contexts/themeProvider'
import { HistoryRouter } from '../../utils/HistoryRouter'

const MODULE_NAME = 'integrations-module'

class IntegrationsWebComponent extends DOMModel {
  @byAttrVal organizationId: string
  @registerEvent('navigate') navigate: Function
  @registerEvent('activateIntegration') activateIntegration: Function
  @registerEvent('deactivateIntegration') deactivateIntegration: Function
  @registerEvent('reloadPaymentMethods') reloadPaymentMethods: Function
}

type IntegrationsProps = {
  organizationId: string
  onNavigate: EmberNavigate
  onActivateIntegration: EmberActivateIntegration
  onDeactivateIntegration: EmberDeactivateIntegration
  onReloadPaymentMethods: EmberReloadPaymentMethods
}

const IntegrationsModule = ({
  organizationId,
  onNavigate,
  onActivateIntegration,
  onDeactivateIntegration,
  onReloadPaymentMethods,
}: IntegrationsProps): ReactElement => (
  <ThemeProvider>
    <HistoryRouter>
      <QueryClientProvider client={queryClient}>
        <EmberRouterContextProvider onNavigate={onNavigate}>
          <ModalContextProvider>
            <EmberIntegrationContextProvider
              onActivateIntegration={onActivateIntegration}
              onDeactivateIntegration={onDeactivateIntegration}
              onReloadPaymentMethods={onReloadPaymentMethods}
            >
              <CurrentUserContextProvider>
                <UserOrganizationContextProvider organizationId={organizationId}>
                  <UserOrganizationSettingsContextProvider organizationId={organizationId}>
                    <IsTrustedPartnerContextProvider organizationId={organizationId}>
                      <AccountsContextProvider organizationId={organizationId}>
                        <Integrations />
                      </AccountsContextProvider>
                    </IsTrustedPartnerContextProvider>
                  </UserOrganizationSettingsContextProvider>
                </UserOrganizationContextProvider>
              </CurrentUserContextProvider>
            </EmberIntegrationContextProvider>
          </ModalContextProvider>
        </EmberRouterContextProvider>
      </QueryClientProvider>
    </HistoryRouter>
  </ThemeProvider>
)

const IntegrationsCustomElement = createCustomElement(IntegrationsModule, IntegrationsWebComponent, 'element')

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, IntegrationsCustomElement)

export default IntegrationsCustomElement
